module.exports = __webpack_public_path__ + "static/img/btn_shangchuan_nor@3x.7da69f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/IdentitAuthentication/images/btn_shangchuan_nor@3x.png
// module id = n2qh
// module chunks = 1